import { request } from '@/shared/api/request'

export const getXml = ({params}) => {
	return request({ url: 'staff/xml/getNoCompressed', method: 'GET', params })
}
